<button type="button" class="btn btn-link" [class.text-danger]="danger" [title]="title">
  {{ text }}
</button>
